import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { RootState } from "../../../store";

export const selector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentDimensions.select();

export const getUsersMeOrganisationsCurrentDimensionsSelector = (
  state: RootState,
) => selector(state);
